export const ERROR = 'ERROR'
export const SUCCESS = 'SUCCESS'



// WEBPACK FOOTER //
// ./src/constants/notifications.ts